import { Component } from '@angular/core';
import { AutenticationService } from './shared/service/autentication/autentication.service';
import { GlobalService } from '@service/global/global.service';
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'BRAC';
  message: any = null;

  spinnerMessage: string = 'Processing. Please Wait....';

  constructor(private globalService: GlobalService) {}

  ngOnInit(): void {
    this.globalService.spinnerMessage$.subscribe(msg => {
      this.spinnerMessage = msg;
    });
  }

  // requestPermission() {
  //   const messaging = getMessaging();
  //   getToken(messaging,
  //     { vapidKey: environment.firebase.vapidKey }).then(
  //       (currentToken) => {
  //         if (currentToken) {
  //           console.log("Hurraaa!!! we got the token.....");
  //           console.log(currentToken);
  //         } else {
  //           console.log('No registration token available. Request permission to generate one.');
  //         }
  //       }).catch((err) => {
  //         console.log('An error occurred while retrieving token. ', err);
  //       });
  // }

  // listen() {
  //   const messaging = getMessaging();
  //   onMessage(messaging, (payload) => {
  //     console.log('Message received. ', payload);
  //     this.message = payload;
  //   });
  // }
}
